import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { CriticalDatesEditModal } from '../components/CritialDatesEditModal'
import {
  actionCreators,
  ICriticalDatesEditState,
  selectError,
  selectOffset,
  selectIsOpen,
  selectIsSaving,
} from '../modules/criticalDatesEdit'

export default connect(
  createStructuredSelector<ApplicationState, ICriticalDatesEditState>({
    error: selectError(),
    offset: selectOffset(),
    isOpen: selectIsOpen(),
    isSaving: selectIsSaving(),
  }),
  actionCreators,
)(CriticalDatesEditModal)
